import { fromJS } from 'immutable';

import { ClientId,ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import {GetDivisionSetting} from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search, body) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiUrl2 + 'division-setting-list';
    if(page === undefined){
        page = 1;
    }

    if (body == undefined) {
        body = {
            'client-id':ClientId
        }
    }
    var query = {
        "search":body,
        "page":page,
        "page-size":10,
        "order-by":1,
        "order":"ASC",
    };

    if(search != null){
        search.map((v,k)=>{
            if(v !== ""){
                query[k] = v;
            }
        });
    }

    var paramBody = {
        "query": query
    };
    //debugger
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };
    //debugger
    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
    }
    //debugger
    dispatch({ type: GetDivisionSetting, data: fromJS(data) });
   
};